import React from 'react';
import './DeviceGrid.css';
import DeviceCard, { Device } from './DeviceCard';

interface DeviceGridProps {
  devices: Device[];
  onUpdateDevice: (deviceId: string, updates: Partial<Device['state']>) => void;
  isLoading?: boolean;
}

const DeviceGrid: React.FC<DeviceGridProps> = ({ devices, onUpdateDevice, isLoading = false }) => {
  // Handle power toggle
  const handleTogglePower = (deviceId: string) => {
    const device = devices.find(d => d.id === deviceId);
    if (device) {
      const newPowerState = device.state.power === 'on' ? 'off' : 'on';
      onUpdateDevice(deviceId, { power: newPowerState });
    }
  };
  
  // Handle value update
  const handleUpdateValue = (deviceId: string, property: string, value: any) => {
    onUpdateDevice(deviceId, { [property]: value });
  };
  
  // Group devices by room
  const devicesByRoom = devices.reduce((acc, device) => {
    const room = device.room || 'Unknown';
    if (!acc[room]) {
      acc[room] = [];
    }
    acc[room].push(device);
    return acc;
  }, {} as Record<string, Device[]>);
  
  // Sort rooms alphabetically
  const sortedRooms = Object.keys(devicesByRoom).sort();
  
  if (isLoading) {
    return (
      <div className="device-grid-loading">
        <div className="loading-spinner"></div>
        <p>Loading devices...</p>
      </div>
    );
  }
  
  if (devices.length === 0) {
    return (
      <div className="device-grid-empty">
        <p>No devices found. Add devices to get started.</p>
      </div>
    );
  }
  
  return (
    <div className="device-grid-container">
      {sortedRooms.map(room => (
        <div key={room} className="room-section">
          <h2 className="room-title">{room}</h2>
          <div className="device-grid">
            {devicesByRoom[room].map(device => (
              <DeviceCard
                key={device.id}
                device={device}
                onTogglePower={handleTogglePower}
                onUpdateValue={handleUpdateValue}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DeviceGrid;